import { getPreferredContact } from "api";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

export default function useGetMultiStopAddressSelect() {
  const { getValues, setValue, trigger } = useFormContext();

  const handleSelectAddress = useCallback((event: any[], index: number) => {
    const address = event[0];
    if (!address) return;

    setValue(`schedule.stops.${index}`, {
      ...getValues(`schedule.stops.${index}`),
      address_id: address.id,

      address_name: address.name,
      street_address: address.street_address,
      street_address_line_two: address.street_address_line_two,
      zipcode: address.zipcode,

      country_name: address.country_name,
      country_id: address.country,
      state_name: address?.state_name,
      state_id: address?.state,
      city_name: address.city_name,
      city_id: address.city,

      ...(address.timezone && { stop_timezone: address.timezone }),
      address_reference_number: address.reference_number,

      un_locode: address.un_locode,
      location_reference_number: address.location_reference_number,
      custom_address_reference: address.custom_address_reference,
    });

    getPreferredContact(address?.reference_number).then((res) => {
      setValue(`schedule.stops.${index}.stop_contact_name`, res.data.name, { shouldValidate: true });
      setValue(`schedule.stops.${index}.stop_contact_number`, res.data.phone_number, {
        shouldValidate: true,
      });
      setValue(`schedule.stops.${index}.stop_contact_email`, res.data.email, { shouldValidate: true });
    });

    trigger(`schedule.stops.${index}.address_name`);
    if (address.timezone) {
      trigger(`schedule.stops.${index}.stop_timezone`);
    }
  }, []);

  return { handleSelectAddress };
}
